import moment from 'moment';

import getListingBreadcrumbName from './getListingBreadcrumbName';

export const LISTING_DOCUMENT_TYPES = {
  INSURANCE: 'INSURANCE',
  UTILITY_MAINTENANCE: 'UTILITY_MAINTENANCE',
  LOAN_FINANCIAL: 'LOAN_FINANCIAL',
  OTHER: 'OTHER',
};

export const documentTypes = {
  INSURANCE: {
    category: 'Landlord Insurance Policy',
    fileRowLabel: 'Landlord Insurance Policy',
  },
  UTILITY_MAINTENANCE: {
    category: 'Utility & Maintenance',
    fileRowLabel: 'Utility & Maintenance',
  },
  LOAN_FINANCIAL: {
    category: 'Loan & Financial Documents',
    fileRowLabel: 'Loan & Financial Documents',
  },
  OTHER: {
    category: 'Other Documents',
    fileRowLabel: 'Other',
  },
};

export const ALLOWED_EXTENSIONS = [
  'jpg',
  'png',
  'jpeg',
  'pdf',
  'zip',
  'xls',
  'xlsx',
  'txt',
  'csv',
  'doc',
  'docx',
];

export function getDocumentGroups(listingDocuments) {
  return listingDocuments.reduce((acc, doc) => {
    const docType = doc.type;

    // Ensure compatibility with both listing_documents and uploaded_documents
    const groupedDoc = {
      ...doc,
      name: doc.title || doc.name,
      ...(doc.expiration_date
        ? {
            subtitle: `EXPIRES ON ${moment(doc.expiration_date).format('MM/DD/YY')}`,
          }
        : {}),
    };

    acc[docType] = [...(acc[docType] || []), groupedDoc];
    return acc;
  }, {});
}

export function collectAndGroupListingDocuments(rootListing) {
  const collectedDocs = [];

  function appendListingDocuments(listing) {
    const { listing_documents = [], uploaded_documents = [] } = listing;

    // Reason we have 2 forEach loops is because ATM we have documents in 2 tables, at some point we will unify them
    // Get listing_documents
    listing_documents.forEach((doc) => {
      collectedDocs.push({
        ...doc,
        listing: { ...listing },
        listing_breadcrumb_name: getListingBreadcrumbName({ listing }),
      });
    });

    // Get uploaded_documents
    // Added additional props so the render function can handle uploaded documents the same way as listing_documents
    uploaded_documents.forEach((doc) => {
      collectedDocs.push({
        ...doc,
        listing: { ...listing },
        listing_breadcrumb_name: getListingBreadcrumbName({ listing }),
        listing_id: doc.location_id,
        type: doc.reported_type,
        type_other_detail: doc.reported_type_other,
        is_uploaded_document: true,
        ...(doc.expiration_date
          ? {
              expiration_date: moment(doc.expiration_date).format('YYYY-MM-DD'),
            }
          : {}),
      });
    });
  }

  function extractDocuments(listing) {
    appendListingDocuments(listing);

    const { children_listings = [] } = listing;

    // Recursively go through children listings
    children_listings.forEach(extractDocuments);
  }

  extractDocuments(rootListing);

  return getDocumentGroups(collectedDocs);
}

export function getFileCategoryLabel(file) {
  return file.type === LISTING_DOCUMENT_TYPES.OTHER && file.type_other_detail
    ? `${documentTypes[file.type].fileRowLabel} - ${file.type_other_detail}`
    : documentTypes[file.type].fileRowLabel;
}
